import React, { useEffect, useState } from 'react';

const ContentSelect = ({ onModelChange, onParallaxModalShow }) => {
    const [showButton, setShowButton] = useState(false);
    const [selectedModel, setSelectedModel] = useState('');
    const [selectedScene, setSelectedScene] = useState('');
    const [isParallaxTrigger, setIsParallaxTrigger] = useState(false);

    useEffect(() => {
      const handleTriggerEnter = (event) => {
        const triggerParts = event.detail.triggerName.split('_');
        const triggerType = triggerParts[0];
        const scene = triggerParts[1];

        setIsParallaxTrigger(false); // Réinitialiser à chaque entrée de trigger

        if (triggerType === 'trigger' && triggerParts.length === 3) {
          // Gestion des triggers pour BoxGlasses
          const model = triggerParts[2];

          setSelectedScene(scene);
          setSelectedModel(model.charAt(0).toUpperCase() + model.slice(1)); // Capitaliser le modelName
          setShowButton(true);
        } else if (triggerParts.length === 2 && ['GTMR', 'monteRosa', 'fortunam', 'OAM', 'riviera'].includes(scene)) {
          // Gestion des triggers spécifiques pour ParallaxModal
          setSelectedScene(scene);
          setIsParallaxTrigger(true);
          setShowButton(true);
        }
      };

      const handleTriggerExit = () => {
        setShowButton(false);
      };

      window.addEventListener('triggerEntered', handleTriggerEnter);
      window.addEventListener('triggerExited', handleTriggerExit);

      return () => {
        window.removeEventListener('triggerEntered', handleTriggerEnter);
        window.removeEventListener('triggerExited', handleTriggerExit);
      };
    }, []);
  
    const handleClick = () => {
      
      if (isParallaxTrigger) {
        onParallaxModalShow(selectedScene);
      } else {
        onModelChange(selectedScene, selectedModel); // selectedScene doit être la couleur, vérifie cette étape
      }
    };
  
    return showButton ? (
      <button
        id="overlayButton"
        style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10 }}
        onClick={handleClick}
      >
        Discover
      </button>
    ) : null;
};

export default ContentSelect;